<template>
    <section class="hashtag-section _preview-section">
        <div class="section-inner">
            <h2 class="heading-section"><span>取り扱い可能地域を検索</span></h2>
            <div class="hashtag-item-wrap">

                <div class="add-hashtag">
                    <div class="input">
                        <input type="text" maxlength="250" class="edit-pen" placeholder="〇〇市" v-model="free_text_area">
                    </div>
                    <button type="button" class="btn" v-on:click="searchArea()">
                        <div class="md_icon-btn _stroke-white">
                            <div class="inner"><SvgIconSearch /></div>
                        </div>
                    </button>
                </div>
                <span style="" v-if="search_area_mes">{{search_area_mes}}</span>

            </div>
        </div><!--/.section-inner-->
    </section>
</template>

<script>
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'

    export default {
        components: {
            SvgIconSearch,
        },
        data() {
            return {
                free_text_area: '',
                search_area_mes: '',
            }
        },
        methods: {
            searchArea: function() {
                axios.post('/brand-search-area-validation',{
                    free_text_area: this.free_text_area
                }).then((res)=>{
                    if (!res.data) {
                        this.search_area_mes = '市町村を入力してください'
                    } else {
                        let preview_area_check = false;
                        for(var i in this.$store.state.register.form.selectAreaLv3) {
                            var AreaLv3 = this.$store.state.register.form.selectAreaLv3[i];
                            if (AreaLv3.name == this.free_text_area) {
                                preview_area_check = true;
                            }
                        }
                        if (preview_area_check) {
                            this.search_area_mes = this.free_text_area + 'は取り扱い可能地域です。詳しくはAUMAトークでお問い合わせください。'
                        } else {
                            this.search_area_mes = this.free_text_area + 'は現在取り扱いできません。'
                        }
                    }
                })
            }
        }
    }
</script>